"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.ResponsiveShape = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_responsive_1 = require("react-responsive");
var styled_1 = __importDefault(require("@emotion/styled"));
var ShapeDiv = function (_a) {
    var children = _a.children, height = _a.height, width = _a.width, position = _a.position, top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, className = _a.className, zIndex = _a.zIndex;
    var Div = (0, styled_1["default"])('div')(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: ", ";\n    height: ", ";\n    width: ", ";\n    top: ", ";\n    right: ", ";\n    left: ", ";\n    bottom: ", ";\n    z-index: ", ";\n  "], ["\n    position: ", ";\n    height: ", ";\n    width: ", ";\n    top: ", ";\n    right: ", ";\n    left: ", ";\n    bottom: ", ";\n    z-index: ", ";\n  "])), position, height, width, top, right, left, bottom, zIndex);
    return (0, jsx_runtime_1.jsx)(Div, __assign({ className: className }, { children: children }), void 0);
};
var ResponsiveShape = function (_a) {
    var children = _a.children, height = _a.height, width = _a.width, position = _a.position, top = _a.top, left = _a.left, right = _a.right, bottom = _a.bottom, className = _a.className, zIndex = _a.zIndex, breakpoints = _a.breakpoints;
    var queries = [];
    for (var i = 0; i < breakpoints.length + 1; i++) {
        var query = void 0;
        if (i === 0) {
            query = (0, react_responsive_1.useMediaQuery)({ maxWidth: breakpoints[i] });
        }
        else if (i === breakpoints.length) {
            query = (0, react_responsive_1.useMediaQuery)({ minWidth: breakpoints[breakpoints.length - 1] + 1 });
        }
        else {
            query = (0, react_responsive_1.useMediaQuery)({ minWidth: breakpoints[i - 1] + 1, maxWidth: breakpoints[i] });
        }
        queries.push(query);
    }
    for (var i = 0; i < queries.length; i++) {
        var query = queries[i];
        if (query) {
            return ((0, jsx_runtime_1.jsx)(ShapeDiv, __assign({ bottom: bottom[i], className: className, height: height[i], left: left[i], position: position, right: right[i], top: top[i], width: width[i], zIndex: zIndex }, { children: children }), void 0));
        }
    }
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}, void 0);
};
exports.ResponsiveShape = ResponsiveShape;
var templateObject_1;
